import React from 'react';

const Cross = () => (React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { clipPath: "url(#clip0)" },
        React.createElement("path", { d: "M10 9.99998L5.05029 14.9497M5.05029 5.05023L10 9.99998L5.05029 5.05023ZM10 9.99998L14.9497 14.9497L10 9.99998ZM10 9.99998L14.9497 5.05023L10 9.99998Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M79 -22H-51C-53.7614 -22 -56 -19.7614 -56 -17V37C-56 39.7614 -53.7614 42 -51 42H79C81.7614 42 84 39.7614 84 37V-17C84 -19.7614 81.7614 -22 79 -22Z", stroke: "currentColor", strokeDasharray: "10 5" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0" },
            React.createElement("rect", { width: "20", height: "20", fill: "white" })))));

export { Cross };
//# sourceMappingURL=Cross.js.map
